// Vendors
import React, { useState } from 'react';
import CountUp from 'react-countup';
import { FundsByApplication } from './components';

const Overview = ({ overviewData, loading, yearToView }) => {
  const [year, setYear] = useState(yearToView);
  const applicableYears = window.wlFipAdmin.applicableYears;

  const handleChangeYear = (e) => {
    setYear(e.target.value);
  };

  const getPaidToDateByYear = (year) =>
    parseInt(overviewData.paid_to_date[year]);

  const getReservedToBePaidByYear = (year) =>
    parseInt(overviewData.reserved_to_be_paid[year]);

  const getApprovedToBePaidByYear = (year) =>
    parseInt(overviewData.approved_to_be_paid[year]);

  const getTotalFundsByYear = (year) =>
    parseInt(overviewData.total_available[year]);

  const getRemainingFundsByYear = (year) =>
    parseInt(overviewData.funds_remaining[year]);

  return (
    <div className="grid u--margin-top-30-md-max">
      <div className="grid__col_xs_12 u--padding-bottom-30 u--padding-left-20">
        <div className="form__select form__select--lg">
          <select
            className="form__input form__input--lg"
            onChange={(event) => handleChangeYear(event)}
          >
            {applicableYears.map(year => (
              <option key={year} value={year}>
                Filter by Year: {year}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="grid__col-xs-12">
        <h3 className="u--margin-bottom-10">FUNDS ALLOCATION</h3>
      </div>

      <div className="grid__col-xs-12 grid__col-md-6 u--text-align-center-sm-max">
        <h4
          className={`h2 u--margin-0 ${loading === true ? 'is-loading' : ''}`}
        >
          {overviewData.paid_to_date[year] > 0 ? (
            <CountUp
              prefix={'$'}
              end={getPaidToDateByYear(year)}
              separator={','}
              duration={1.5}
            />
          ) : (
            '--'
          )}
        </h4>
        <p>Paid To Date</p>
      </div>
      <div className="grid__col-xs-12 grid__col-md-6 u--text-align-center-sm-max">
        <h4
          className={`h2 u--margin-0 ${loading === true ? 'is-loading' : ''}`}
        >
          {overviewData.approved_to_be_paid[year] > 0 ? (
            <CountUp
              prefix={'$'}
              end={getApprovedToBePaidByYear(year)}
              separator={','}
              duration={1.5}
            />
          ) : (
            '--'
          )}
        </h4>
        <p>Approved To Be Paid</p>
      </div>
      <div className="grid__col-xs-12 grid__col-md-6 u--text-align-center-sm-max">
        <h4
          className={`h2 u--margin-0 ${loading === true ? 'is-loading' : ''}`}
        >
          {overviewData.reserved_to_be_paid[year] > 0 ? (
            <CountUp
              prefix={'$'}
              end={getReservedToBePaidByYear(year)}
              separator={','}
              duration={1.5}
            />
          ) : (
            '--'
          )}
        </h4>
        <p>Reserved To Be Paid</p>
      </div>
      <div className="grid__col-xs-12 grid__col-md-6 u--text-align-center-sm-max">
        <h4
          className={`h2 u--margin-0 ${loading === true ? 'is-loading' : ''}`}
        >
          {overviewData.funds_remaining[year] > 0 ? (
            <CountUp
              prefix={'$'}
              start={getTotalFundsByYear(year)}
              end={getRemainingFundsByYear(year)}
              separator={','}
              duration={1.5}
            />
          ) : (
            '--'
          )}
        </h4>
        <p>Remaining Funds Available</p>
      </div>
      <FundsByApplication />
    </div>
  );
};

export default Overview;
